module.exports = __webpack_public_path__ + "static/images/mall-bg.4c359e9.png";